module.exports = function anonymous(it
) {
var out='<section class="definition-container"> <div class="inline fullheight js-definition-builder definition-builder hidden"></div></section>';return out;
}